// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3Vyt6","header":"Messages_header__3mg46"};